import { XMarkIcon } from "@heroicons/react/24/solid";
import { FilterConfig } from "./crud-table";

export interface FilterAppliedProps {
  selectedFilters: Record<string, (string | number)[]>;
  onClearFilters: () => void;
  onRemoveFilter: (filterKey: string, value: string | number) => void;
  filters: FilterConfig[];
}
export function FilterApplied({
  selectedFilters,
  onClearFilters,
  onRemoveFilter,
  filters = [],
}: FilterAppliedProps) {
  const length = Object.keys(selectedFilters).length;

  if (length === 0) {
    return null;
  }

  const filterLabelMap = filters.reduce((acc, filter) => {
    acc[filter.key] = filter.label;
    return acc;
  }, {} as Record<string, string>);

  const filterOptionsMap = filters.reduce((acc, filter) => {
    acc[filter.key] = filter.options.reduce((optAcc, option) => {
      optAcc[String(option.key)] = option.value;
      return optAcc;
    }, {} as Record<string, string>);
    return acc;
  }, {} as Record<string, Record<string, string>>);

  return (
    <div className="bg-gray-50 p-3 rounded-lg mb-3">
      <div className="flex justify-between items-center mb-2">
        <h3 className="text-sm font-medium text-gray-700">
          Filtros activos ({length})
        </h3>
        <button
          onClick={onClearFilters}
          className="text-sm text-red-600 hover:text-red-800 transition-colors"
        >
          Limpiar todos
        </button>
      </div>
      <div className="flex flex-wrap gap-2">
        {Object.entries(selectedFilters).map(([filterKey, values]) => (
          <div
            key={filterKey}
            className="bg-blue-50 text-blue-700 px-2 py-1 rounded-md flex items-center text-xs"
          >
            <span className="font-medium mr-1">
              {filterLabelMap[filterKey] || filterKey}:
            </span>
            <span>
              {values
                .map(
                  (value) =>
                    filterOptionsMap[filterKey]?.[String(value)] || value
                )
                .join(", ")}
            </span>
            <button
              className="ml-1 text-blue-700 hover:text-blue-900"
              onClick={() =>
                values.forEach((value) => onRemoveFilter(filterKey, value))
              }
            >
              <XMarkIcon className="w-4 h-4" />
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
